export const REGISTER_SUCCESS= 'REGISTER_SUCCESS';
export const REGISTER_LOADING = 'REGISTER_LOADING';
export const REGISTER_FAILURE = 'REGISTER_FAILURE';
export const REGISTER_COMPLETE = 'REGISTER_COMPLETE';


